export default {
	type: 'object',
	properties: {
		brandName: { type: 'string' },
		brandWebsite: { type: 'string' },
		brandTwitter: { type: 'string' },
		brandLogo: {
			type: 'object',
			properties: {
				small: { type: 'string' },
				big: { type: 'string' },
			},
			additionalProperties: false,
		},
		id: { type: 'string' },
	},
	required: ['brandName', 'brandWebsite'],
	additionalProperties: false,
}
